import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { BREAKPOINT_VALUES } from '../../utils/constants/Breakpoints';
import { Helmet } from 'react-helmet';

export const TABLET_BREAKPOINT = BREAKPOINT_VALUES.xxl;
export const MOBILE_BREAKPOINT = BREAKPOINT_VALUES.md;

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.beacon.midnight,
    backgroundColor: theme.palette.beacon.surf,
    minHeight: '100vh',
    height: 'min-content',
    margin: '0 auto',
    position: 'relative',
    display: 'flex',
    width: '100%',
    maxWidth: 1536,
    flexDirection: 'column',
    overflowX: 'clip',
    [theme.breakpoints.up(TABLET_BREAKPOINT)]: {
      flexGrow: 1,
      flexDirection: 'row-reverse',
      paddingTop: theme.spacing(13),
      paddingRight: theme.spacing(5),
      maxHeight: '100%',
      boxSizing: 'border-box',
      overflowY: 'clip',
    },
  },

  backgroundImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    [theme.breakpoints.up(TABLET_BREAKPOINT)]: {
      borderTopLeftRadius: 123,
    },
  },
  backgroundImageContainer: {
    height: 280,
    [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
      height: 555,
    },
    [theme.breakpoints.up(TABLET_BREAKPOINT)]: {
      width: '40%',
      height: 'auto',
    },
  },
  content: {
    margin: theme.spacing(4.5, 2),
    [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
      margin: theme.spacing(4.5, 5),
    },
    [theme.breakpoints.up(TABLET_BREAKPOINT)]: {
      width: '60%',
      overflow: 'auto',
    },
  },
}));

/**
 * Layout component for each onboarding step.
 *
 * @param {object} props
 * @param {string} props.backgroundImage - background image path
 * @param {object} props.classesOverride - override for custom classes
 * @param {React.ReactNode} props.children - children
 * @returns {React.ReactElement}
 */
export const Layout = ({ backgroundImage, classesOverride, children }) => {
  const classes = useStyles({ classes: classesOverride });

  return (
    <>
      <Helmet>
        <link rel="preload" as="image" href={backgroundImage} />
      </Helmet>
      <Box className={classes.root}>
        <Box className={classes.backgroundImageContainer}>
          <img
            src={backgroundImage}
            alt=""
            className={classes.backgroundImage}
          />
        </Box>
        <Box className={classes.content}>{children}</Box>
      </Box>
    </>
  );
};
